import React from 'react';

import classes from './styles.module.scss';

interface Props {
    inverted?: boolean;
    size?: string;
    loader?: boolean;
    testId?: string;
    useDataAttribute?: boolean;
    newLoader?: boolean;
}

function Spinner({ inverted, size, loader, testId, useDataAttribute }: Props) {
    const themeColor = window.rapidstor_settings.app_config.journey.themeColor;

    return (
        <div
            id='spinner'
            className={`${inverted ? classes.inverted : ''} ${classes.spinner} ${loader ? classes.loader : ''
                }`}
            data-testid={testId ?? 'spinner'}
            style={{
                marginTop: '',
                height: size ? `${size}px` : '30px',
                width: size ? `${size}px` : '30px',
                borderTopColor: useDataAttribute && themeColor ? themeColor : '',
            }}
        ></div>
    );
}

export default Spinner;
